import type { ThemeProps } from '@radix-ui/themes';

export const PORTAL_THEME_PROPS: Pick<ThemeProps, 'accentColor' | 'grayColor' | 'radius' | 'scaling'> = {
  accentColor: 'violet',
  grayColor: 'slate',
  radius: 'medium',
  scaling: '100%',
};
